// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"az_UDb","disableScrollBar":"az_VDb","modalTooltip":"az_WDb"};